import { marketPrivateView } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const market_private_view = (id) => axiosAuthInstance.put(marketPrivateView.market_private_view.replace(':id', id));

export const confirm_trade_offer_accepted = (body) => axiosAuthInstance.post(marketPrivateView.confirm_trade_offer_accepted, body);
export const buyer_accept_trade = (body) => axiosAuthInstance.post(marketPrivateView.buyer_accept_trade, body);
